export const environment = {
  production: false,
  interval: 2000,
  enableServiceWorker: false,
};
